module.exports = __webpack_public_path__ + "img/IMG_0577_8_9_L_Wood_MockedUp.4b00cd63.jpg";